import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  background-color: var(--white);
  color: var(--text-body);
  font-size: 0.9rem;
`;

export const TitleContainer = styled.div`
  position: relative;
  display: flex;
  background-color: var(--titleBkgColor);
`;

export const TitleBackButton = styled.button`
  position: absolute;
  display: flex;
  border: none;
  width: 3rem;
  height: 100%;

  justify-content: center;
  align-items: center;
  padding: 0.2rem;
  left: 1rem;

  font-size: 0.7rem;
  background-color: transparent;
  color: var(--secundary);

  svg {
    margin-right: 0.3rem;
    font-size: 1rem;
    color: var(--primary);
  }
`;

export const Title = styled.text`
  width: 100%;
  text-align: center;
  align-self: center;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--titleColor);
  padding: 5px 0;

  @media (max-width: 500px) {
    font-size: 1.2rem;
  }
`;

export const ContainerWrapper = styled.div`
  display: block;
  max-height: calc(100vh - 12.6rem);
  overflow-y: auto;

  .layoutResponsiveGrid {
    display: flex;
  }
`;

export const ContentLeft = styled.div`
  background-color: darkgreen;
`;

export const ContentMain = styled.div`
  background-color: darkgreen;
`;

// *** Specific of the page ***
